export default __webpack_public_path__ + "static/media/mercedesbenz.abad5932.webp";